import { useState } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import { ConnectorSecret } from "../models/Connector";
import { useTranslation } from "react-i18next";

type ConnectorSecretFieldProps = Omit<TextFieldProps, "value" | "onChange"> & {
  value: ConnectorSecret;
  onChange: (value: ConnectorSecret) => void;
};

export function ConnectorSecretField({
  value: connectorSecret,
  onChange,
  InputProps: parentInputProps,
  ...props
}: ConnectorSecretFieldProps) {
  const { t } = useTranslation(["common"]);
  const [isEditing, setIsEditing] = useState(false);

  const onEditPressed = () => {
    setIsEditing(true);
    onChange({
      ...connectorSecret,
      value: "",
    });
  };

  const onCancelPressed = () => {
    setIsEditing(false);
    onChange({
      ...connectorSecret,
      value: "",
    });
  };

  const hasMaskedValue =
    connectorSecret.isSensitive &&
    !connectorSecret.value &&
    connectorSecret.hasValue;

  const showChangeButton = hasMaskedValue && !isEditing;
  const showCancelButton = hasMaskedValue && isEditing;

  return (
    <TextField
      {...props}
      onChange={(event) => {
        onChange({
          ...connectorSecret,
          value: event.target.value,
        });
      }}
      type={connectorSecret.isSensitive ? "password" : "text"}
      autoComplete="off"
      value={showChangeButton ? "********" : connectorSecret.value}
      disabled={showChangeButton || props.disabled}
      InputProps={{
        ...parentInputProps,
        endAdornment: (showChangeButton || showCancelButton) && (
          <InputAdornment position="end">
            {showChangeButton && (
              <Button size="small" onClick={onEditPressed}>
                {t("common:edit")}
              </Button>
            )}
            {showCancelButton && (
              <Button size="small" onClick={onCancelPressed}>
                {t("common:cancel")}
              </Button>
            )}
          </InputAdornment>
        ),
      }}
    />
  );
}
